var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.destroyed)?_c('qrcode-stream',{staticClass:"camera-qr",on:{"decode":_vm.onDecode,"init":_vm.onInit}},[(_vm.loading)?_c('div',{staticClass:"loading-indicator"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"red"}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }